package com.iregained.site.components.sections.corporate.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val ProcurementCardStyle = CssStyle {
    base {
        Modifier.transition(
            Transition.of("transform", 300.ms),
            Transition.of("box-shadow", 300.ms),
            Transition.of("border-color", 300.ms)
        )
    }
    hover {
        Modifier.scale(1.02f).boxShadow(0.px, 16.px, 40.px, color = Colors.Black.copyf(alpha = 0.12f))
    }
}

val ActionButtonStyle = CssStyle {
    base {
        Modifier.transition(
            Transition.of("background-color", 200.ms),
            Transition.of("transform", 150.ms),
            Transition.of("opacity", 200.ms)
        )
    }
    hover {
        Modifier.opacity(0.9f).scale(1.01f)
    }
}

val AudienceToggleTabStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("background-color", 200.ms))
    }
}

val PolicyBodyTextStyle = CssStyle {
    // Target any nested <p> tags injected via innerHTML to strip extra default browser margins
    cssRule(" p") {
        Modifier.margin(top = 0.px, bottom = 8.px)
    }
    // Target nested unordered lists similarly
    cssRule(" ul") {
        Modifier.margin(top = 0.px, bottom = 8.px)
    }
    cssRule(" li") {
        Modifier.margin(bottom = 6.px)
    }
}